import axios from "axios";

export default {
  namespaced: true,
  state: {
    logo: null,
    accountSectionsIconsAndPath: [
      { name: "Главная", icon: "Home", path: "/app/home" },
      {
        name: "Профиль администратора",
        icon: "Profile",
        path: "/app/administrator-profile",
      },
      { name: "Профиль врача", icon: "Profile", path: "/app/doctor-profile" },
      {
        name: "Профиль эксперта",
        icon: "Profile",
        path: "/app/expert-profile",
      },
      {
        name: "Пациенты",
        engName: "Patients",
        icon: "Users",
        path: "/app/patients",
      },
      { name: "Роли Системы", icon: "Roles", path: "/app/roles" },
      { name: "Справочники", icon: "OpenBook", path: "/app/guide" },
      { name: "Отчеты", icon: "ChartPie", path: "/app/reports" },
      { name: "Режимы Системы", icon: "Settings", path: "/app/sections" },
      { name: "Пользователи", icon: "Users", path: "/app/users" },
    ],
    user: {
      accountSections: [],
      isDisabled: null,
      email: "",
      fname: "",
      group: null,
      groupId: null,
      iname: "",
      login: "",
      logoUrl: null,
      oname: "",
      photoUrl: null,
      roleId: "",
      sections: [
        {
          id: "847aa282-f41f-4f5e-9979-52c987fc8582",
          isDisabled: false,
          keyName: "Patients",
          engName: "Patients",
          name: "Пациенты",
          placeholder: null,
          subsections: [],
          icon: "Users",
          path: "/app/patients",
        },
      ],
      refBooks: [],
      specialityIds: [],
    },
    node: null,
    stats_tree: null,
    code_sucess: null,
    password_sucess: null,
  },
  getters: {
    userInfo: (state) => state.user,
    accessRights: (state) => state.user.accessRights,
    isComplete: (state) => state.node,
    statsTree: (state) => state.stats_tree,
    getSections: (state) => state.user.sections,
  },
  mutations: {
    addFile(state, image) {
      state.logo = image;
    },
    setUser(state, user) {
      console.log(state, user);
      let arrSec = [];

      for (let i = 0; i < user.sections.length; i++) {
        for (let j = 0; j < state.accountSectionsIconsAndPath.length; j++) {
          if (
            user.sections[i].name ===
              state.accountSectionsIconsAndPath[j].name &&
            user.sections[i].keyName === "Patients"
          ) {
            user.sections[i].path = state.accountSectionsIconsAndPath[j].path;
            user.sections[i].icon = state.accountSectionsIconsAndPath[j].icon;
            user.sections[i].engName =
              state.accountSectionsIconsAndPath[j].engName;

            arrSec.push(user.sections[i]);

            console.log(user.sections[i], state.accountSectionsIconsAndPath[j]);
          }
        }
      }
      state.user = { ...user, sections: arrSec };
    },
    setGroup(state, group) {
      state.group = group;
    },
    codeSucess(state, data) {
      state.code_sucess = data;
    },
    passwordSucess(state, data) {
      state.password_sucess = data;
    },
    setNodeComplete(state, data) {
      state.node = data;
    },
    stats(state, data) {
      state.stats_tree = data;
    },
  },
  actions: {
    uploadLogo({ commit, rootState }, image) {
      console.log(image.target.files[0]);
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("file", image.target.files[0]);
        axios
          .post(`${rootState.api}User/UploadLogo`, formData, {
            "Content-Type": "multipart/form-data",
          })
          .then((resp) => {
            commit("addFile", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateUser({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/Update`, data)
          .then((resp) => {
            commit("setUser", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserInfo({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/GetUserInfo`)
          .then((resp) => {
            commit("setUser", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    searchGroups({ commit, rootState }, search) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/SearchGroups?q=${search}`)
          .then((resp) => {
            commit("setGroup", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendCode({ commit, rootState }, email) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/SendRecoveryCode?email=${email}`)
          .then((resp) => {
            commit("codeSucess", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    checkCode({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}User/CheckRecoveryCode?email=${data.email}&code=${data.code}`,
          )
          .then((resp) => {
            commit("codeSucess", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    changePassword({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(
            `${rootState.api}User/ChangePassword?email=${data.email}&pass1=${data.newPassword}&pass2=${data.repeatPassword}`,
          )
          .then((resp) => {
            commit("passwordSucess", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nodeComplete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${rootState.api}User/SetNodeAsComplete?nodeId=${id}`)
          .then((resp) => {
            commit("setNodeComplete", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getStatsTree({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${rootState.api}User/GetStatTree`)
          .then((resp) => {
            commit("stats", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
